



























































































































































import { Component, Vue } from 'vue-property-decorator'
import { UserStore, userInfoTypes } from '@/store/modules/User'
import { BaseStore } from '@/store/modules/Base'
import { uploadToken, fileSuccess } from '@/api/file'
import { mchUserModify, getUserInfo } from '@/api/user'
import { addMchNotice, getMchNotice } from '@/api/com'
import { httpsImg } from '@/utils/tool'

interface BusinessType {
  show: boolean
}

@Component({
  name: 'Business',
  beforeRouteUpdate (to, from, next) {
    if (to.path.includes('/business/merchant')) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore 忽略 this.show 在vscode中监测不到，实际能够有的值
      this.show = false
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore 忽略 this.show 在vscode中监测不到，实际能够有的值
      this.show = true
    }
    next()
  }
})
export default class Business extends Vue implements BusinessType {
  loadingBtn = false

  show = false

  dialogVisible = false

  imgPreview = false // 图片上传预览

  subShow = false

  accountBalance = '' // 账户余额

  noticePhone = '' // 通知手机

  httpsImg = httpsImg

  // 设置功能 - 表单数据
  form = {
    mchPhone: '',
    mchQq: '',
    // mchWebSite: '',
    mchWxQrcode: '',
    mchDesc: ''
  }

  uploadToken = {}

  rules = {
    mchPhone: [
      { required: true, message: '电话不能为空', trigger: 'blur' }
    ],
    mchQq: [
      { required: true, message: 'QQ号不能为空', trigger: 'blur' }
    ],
    // mchWebSite: [
    //   { required: true, message: '网址不能为空', trigger: 'blur' }
    // ],
    mchWxQrcode: [
      { required: true, message: '微信二维码不能为空', trigger: 'blur' }
    ],
    mchDesc: [
      { required: true, message: '商家介绍不能为空', trigger: 'blur' }
    ]
  }

  // 星星显示数量
  get rateValue () :number {
    return Number(this.info.systemGrade) / 2
  }

  // 如果有 商户信息就要显示商户信息 -- 否则就显示自己的信息
  get info (): userInfoTypes {
    if (BaseStore.clientInfo.parentMchId) {
      return BaseStore.clientInfo
    }
    return UserStore.userInfo
  }

  get subWidth (): string {
    const w = document.body.clientWidth
    if (w < 769) {
      return '80%'
    }
    return '40%'
  }

  // 图片获取
  handleAvatarSuccess (res): void {
    this.$set(this.form, 'mchWxQrcode', 'http://qnimg.zowoyoo.com/' + res.key)
  }

  // 图片上传前的校验
  async beforeAvatarUpload (file) {
    console.log('图片上传前的校验')
    console.log(file)
    const isImage = file.type.includes('image')
    const isLt2M = file.size / 1024 / 1024 < 2

    if (!isImage) {
      this.$message.error('上传头像必须是个图片!')
    }
    if (!isLt2M) {
      this.$message.error('上传头像图片大小不能超过 2MB!')
    }
    const res = await uploadToken({
      fileName: file.name,
      fileSize: file.size,
      objectId: new Date().getTime(),
      objectType: 'mch_user',
      saasId: this.info.parentMchId
    })
    if (res.success) {
      this.uploadToken = {
        key: res.data.key,
        token: res.data.token
      }
      // 通知一下后台文件上传成功
      fileSuccess({
        id: res.data.id,
        saasId: this.info.parentMchId
      })
    } else {
      this.$message({
        type: 'error',
        message: '获取上传权限失败!请稍后再试!'
      })
      return false
    }

    return isImage && isLt2M
  }

  // 保存修改
  saveChanges () {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.$refs.BusForm.validate((valid) => {
      if (valid) {
        console.log('有效的')
        this.loadingBtn = true
        mchUserModify(this.form)
          .then(res => {
            this.loadingBtn = false
            this.dialogVisible = false
            if (Number(res) === 1) {
              this.getUserInfo()
              this.$message({
                message: '保存成功!',
                type: 'success'
              })
            } else {
              this.$message({
                type: 'error',
                message: '保存失败!'
              })
            }
          })
      }
    })
  }

  // 请求服务数据 用户信息
  async getUserInfo () {
    const res = await getUserInfo()
    if (res.mchName) {
      UserStore.SET_USER_INFO(res)
    }
  }

  clickSetting () {
    const values = Object.keys(this.form)
    for (const key in values) {
      this.$set(this.form, values[key], this.info[values[key]])
    }
    this.dialogVisible = true
  }

  clickSub () {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    getMchNotice(this.info.parentMchId)
      .then((res) => {
        loading.close()
        console.log(res)
        if (res.success && res.data) {
          this.accountBalance = res.data.accountBalance
          this.noticePhone = res.data.noticePhone
        }
        this.subShow = !this.subShow
      }).catch((err) => {
        loading.close()
        console.error(err)
      })
  }

  clickSubConfirm () {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    addMchNotice({
      accountBalance: this.accountBalance,
      mchId: this.info.parentMchId,
      noticePhone: this.noticePhone,
      noticeType: [1]
    }).then(res => {
      loading.close()
      this.subShow = !this.subShow
      if (!res.success) {
        this.$message.error(res.msg || '设置失败，请稍后重试！')
      }
    })
  }

  mounted (): void {
    if (!this.$route.path.includes('/business/merchant')) {
      this.show = true
    }
  }
}
